import { c as _c } from "react/compiler-runtime";
import { MutationFunction, useMutation } from '@tanstack/react-query';
import { ApiError } from '../instance/error';
import { queryClient } from './query-client';
type MutateOptions<TData = unknown, TVariables = void> = {
  mutationFn: MutationFunction<TData, TVariables>;
  onSuccess?: (data: TData, variables: TVariables) => void;
  onError?: (error: ApiError, variables: TVariables) => void;
};
export const createMutationDefaults = <TData, TVariables = void>(mutationKeys: [string], options: MutateOptions<TData, TVariables>) => queryClient.setMutationDefaults(mutationKeys, {
  mutationFn: options.mutationFn,
  onSuccess: options.onSuccess,
  onError: options.onError
});
type UseMutationStoreOptions = {
  throwOnError?: (error: Error) => boolean;
};
export const useMutationStore = (mutationKey, options) => {
  const $ = _c(7);
  let t0;
  if ($[0] !== mutationKey) {
    t0 = [mutationKey];
    $[0] = mutationKey;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options) {
    t1 = options?.throwOnError && {
      throwOnError: options.throwOnError
    };
    $[2] = options;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      mutationKey: t0,
      ...t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useMutation(t2);
};

/* eslint-disable @typescript-eslint/no-empty-object-type */
export interface MutationRegistry {}
export type MutationKeyType = keyof MutationRegistry;